import { Navigate, Route, Routes as RoutesDOM } from "react-router-dom";
import { Login } from "../pages/Login/Login";
import { Invitation } from "../pages/Invitation/Invitation";
import PrivateRoute from "./PrivateRoute";
import { Dashboard } from "../pages/Dashboard/Dashboard";
import { UpdateVehicule } from "../pages/Vehicule/UpdateVehicule/UpdateVehicule";
import { ListVehicule } from "../pages/Vehicule/ListVehicule/ListVehicule";
import { CreateVehicule } from "../pages/Vehicule/CreateVehicule/CreateVehicule";
import { CreateEvent } from "../pages/Vehicule/UpdateVehicule/CreateEvent/CreateEvent";
import { EventDetail } from "../pages/Vehicule/UpdateVehicule/EventDetail/EventDetail";
import { VehicleHistory } from "../pages/Vehicule/UpdateVehicule/VehicleHistory/VehicleHistory";
import { UpdateCollaborator } from "../pages/Collaborator/UpdateCollaborator/UpdateCollaborator";
import { ListCollaborator } from "../pages/Collaborator/ListCollaborator/ListCollaborator";
import { CreateCollaborator } from "../pages/Collaborator/CreateCollaborator/CreateCollaborator";
import { ListNotification } from "../pages/Notification/ListNotification/ListNotification";
import { CreateClaims } from "../pages/Claims/CreateClaims/CreateClaims";
import { ListClaims } from "../pages/Claims/ListClaims/ListClaims";
import { UpdateClaims } from "../pages/Claims/UpdateClaims/UpdateClaims";
import { CarteAndBadge } from "../pages/CarteAndBadge/CarteAndBadge";
import { TCO } from "../pages/TCO/TCO";
import { Fiscalite } from "../pages/Fiscalite/Fiscalite";
import { Analyses } from "../pages/Analyses/Analyses";
import { Parametre } from "../pages/Parametre/Parametre";
import { RedirectEmployee } from "../pages/RedirectEmployee/RedirectEmployee";
import { EnterCodeForgotPassword } from "../pages/EnterCodeForgotPassword/EnterCodeForgotPassword";
import { ForgotPassword } from "../pages/ForgotPassword/ForgotPassword";
import { EnterEmailForgotPassword } from "../pages/EnterEmailForgotPassword/EnterEmailForgotPassword";
import { Geolocalisation } from "../pages/Geolocalisation/Geolocalisation";
import { BatteryHealthVehicule } from "../pages/Vehicule/BatteryHealthVehicule/BatteryHealthVehicule";
import { Billing } from "../pages/Billing/Billing";
import { AiAgent } from "../pages/AiAgent";
import { Aide } from "../pages/Aide/Aide";
import { ListDocuments } from "../pages/Documents/ListDocuments/ListDocuments";
import { Register } from "../pages/Register/Register";
import { RegisterComplete } from "../pages/Register/RegisterComplete";
import { DpaPage, TermsPage } from "../pages/Legal/LegalDocumentPage";
import RequireSubscription from "./RequireSubscription";
import { NotFound } from "../pages/NotFound/NotFound";
import { AppLayout } from "../layouts/AppLayout";
import { RouteSeo } from "../seo";

export const Routes = () => {
  const isAuthentificated = !!localStorage.getItem("token");
  return (
    <>
      {/* Keeps <title>, robots, canonical and OG tags in sync with the route.
          Route metadata lives in src/seo/seo.config.ts. */}
      <RouteSeo />
      <RoutesDOM>
      {/* ══ PUBLIC ═══════════════════════════════════════════════════════
          No navigation chrome. These must stay outside <AppLayout>, which
          mounts the fleet sidebar. */}
      <Route path="/employee" element={<RedirectEmployee />} />
      {/* ── Self-serve signup ───────────────────────────────────────────
          /register        public wizard: account → plan → Stripe Checkout
          /register/plan   resume point for an account with no subscription
                           (abandoned checkout, or RequireSubscription bounce)
          /register/complete  post-Stripe landing; polls until the webhook
                           has written the subscription, then goes to /dashboard
      */}
      <Route path="/register" element={<Register />} />
      {/* ── Documents contractuels ────────────────────────────────────
          Publics et hors AppLayout : on y arrive depuis le formulaire
          d'inscription, donc avant d'avoir un compte. Les monter derriere
          PrivateRoute les rendrait inaccessibles a la personne qui en a le plus
          besoin -- celle qui s'apprete a cocher la case.

          Ils remplacent les liens vers /legal/*.docx : ces fichiers ne sont pas
          dans le depot (public/legal/ ne contient qu'un README), donc les deux
          liens de consentement repondaient 404. */}
      <Route path="/legal/terms" element={<TermsPage />} />
      <Route path="/legal/dpa" element={<DpaPage />} />
      <Route
        path="/register/plan"
        element={
          <PrivateRoute>
            <Register />
          </PrivateRoute>
        }
      />
      <Route
        path="/register/complete"
        element={
          <PrivateRoute>
            <RegisterComplete />
          </PrivateRoute>
        }
      />
      {/*
        Root.
        Signed out it is the login screen. Signed in it forwards to /dashboard
        rather than rendering the dashboard a second time under a second URL:
        the app shell below is a layout route, and "/" cannot both live inside
        it (so the panel mounts) and render <Login /> outside it. One canonical
        URL per screen is also what the SEO config and analytics assume.
      */}
      <Route
        path="/"
        element={isAuthentificated ? <Navigate to="/dashboard" replace /> : <Login />}
      />
      {/* Invitation landing page (confirmation d'ajout). The legacy
          /generate_password path from already-sent emails now lands on the
          same improved page. */}
      <Route path="/invitation" element={<Invitation />} />
      <Route path="/generate_password" element={<Invitation />} />
      <Route path="/enter_email_forgot_password" element={<EnterEmailForgotPassword />} />
      <Route path="/enter_code_forgot_password" element={<EnterCodeForgotPassword />} />
      <Route path="/forgot_password" element={<ForgotPassword />} />

      {/* ══ AUTHENTICATED APP ════════════════════════════════════════════
          A pathless layout route. Its element stays mounted while only the
          <Outlet /> swaps, so the sidebar panel is built once per session
          instead of once per navigation -- which is what keeps the company
          fetch, the menu scroll position and the active-item animation alive
          across page changes. Every screen with navigation belongs in here.

          PrivateRoute / RequireSubscription stay on the individual routes:
          the guards differ per screen (/billing must remain reachable without
          an active subscription, or a lapsed customer could never pay). */}
      <Route element={<AppLayout />}>
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <RequireSubscription>
                <Dashboard />
              </RequireSubscription>
            </PrivateRoute>
          }
        />
        <Route
          path="/billing"
          element={
            <PrivateRoute>
              <Billing />
            </PrivateRoute>
          }
        />
        <Route
          path="/ai-agent"
          element={
            <PrivateRoute>
              <RequireSubscription><AiAgent /></RequireSubscription>
            </PrivateRoute>
          }
        />
        <Route
          path="/aide"
          element={
            <PrivateRoute>
              <Aide />
            </PrivateRoute>
          }
        />
        <Route
          path="/carteAndBadge"
          element={
            <PrivateRoute>
              <RequireSubscription><CarteAndBadge /></RequireSubscription>
            </PrivateRoute>
          }
        />
        <Route
          path="/geolocalisation"
          element={
            <PrivateRoute>
              <RequireSubscription><Geolocalisation /></RequireSubscription>
            </PrivateRoute>
          }
        />
        <Route path="/vehicule">
          <Route path="create" element={<PrivateRoute><RequireSubscription><CreateVehicule /></RequireSubscription></PrivateRoute>} />
          <Route path="update/:id" element={<PrivateRoute><RequireSubscription><UpdateVehicule /></RequireSubscription></PrivateRoute>} />
          <Route path="update/:id/create-event" element={<PrivateRoute><RequireSubscription><CreateEvent /></RequireSubscription></PrivateRoute>} />
          <Route path="update/:id/event/:eventId" element={<PrivateRoute><RequireSubscription><EventDetail /></RequireSubscription></PrivateRoute>} />
          <Route path=":id/history" element={<PrivateRoute><RequireSubscription><VehicleHistory /></RequireSubscription></PrivateRoute>} />
          <Route path="battery-health/:id" element={<PrivateRoute><RequireSubscription><BatteryHealthVehicule /></RequireSubscription></PrivateRoute>} />
          <Route path="list" element={<PrivateRoute><RequireSubscription><ListVehicule /></RequireSubscription></PrivateRoute>} />
        </Route>
        <Route path="/collaborator">
          <Route path="create" element={<PrivateRoute><RequireSubscription><CreateCollaborator /></RequireSubscription></PrivateRoute>} />
          <Route path="update/:id" element={<PrivateRoute><RequireSubscription><UpdateCollaborator /></RequireSubscription></PrivateRoute>} />
          <Route path="list" element={<PrivateRoute><RequireSubscription><ListCollaborator /></RequireSubscription></PrivateRoute>} />
        </Route>
        <Route path="/notification">
          <Route path="list" element={<PrivateRoute><RequireSubscription><ListNotification /></RequireSubscription></PrivateRoute>} />
        </Route>
        <Route path="/claims">
          <Route path="create" element={<PrivateRoute><RequireSubscription><CreateClaims /></RequireSubscription></PrivateRoute>} />
          <Route path="update/:id" element={<PrivateRoute><RequireSubscription><UpdateClaims /></RequireSubscription></PrivateRoute>} />
          <Route path="list" element={<PrivateRoute><RequireSubscription><ListClaims /></RequireSubscription></PrivateRoute>} />
        </Route>
        <Route path="/documents">
          <Route path="list" element={<PrivateRoute><RequireSubscription><ListDocuments /></RequireSubscription></PrivateRoute>} />
        </Route>
        <Route path="/tco" element={<PrivateRoute><RequireSubscription><TCO /></RequireSubscription></PrivateRoute>} />
        {/* Analyse & optimisation. The plan check happens twice on purpose:
            FeatureGate inside each page handles the in-app upsell, and the
            `quota:<feature>` middleware on the API is the actual boundary. */}
        <Route path="/fiscalite" element={<PrivateRoute><RequireSubscription><Fiscalite /></RequireSubscription></PrivateRoute>} />
        <Route path="/analyses" element={<PrivateRoute><RequireSubscription><Analyses /></RequireSubscription></PrivateRoute>} />
        <Route path="/parametre" element={<PrivateRoute><RequireSubscription><Parametre /></RequireSubscription></PrivateRoute>} />
      </Route>

      {/* Catch-all. Must stay LAST: react-router picks the best match rather
          than the first, but keeping it here makes the intent obvious.
          Without it an unmatched URL rendered an empty <RoutesDOM> -- a blank
          white page with no message and no way back.
          Outside the layout on purpose: a 404 has no navigation to belong to. */}
      <Route path="*" element={<NotFound />} />
      </RoutesDOM>
    </>
  );
};
